/** @file Semantic radius tokens for consistent border-radius values. */

export const radius = {
  control: '8px', // buttons, inputs, chips
  surface: '16px', // cards, dialogs, popovers
  media: '20px', // image containers, map frame
  pill: '999px' // badges, avatars
};
